var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLibro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_libro",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_27",
    "data-name": "Rect\\xE1ngulo 27",
    width: 100,
    height: 100,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_120",
    "data-name": "Trazado 120",
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0M79.223,70.985a2.433,2.433,0,0,1-.089.708c-.351,1.134-1.395,1.553-2.747,1.158a46.536,46.536,0,0,0-15.3-2.054,26.153,26.153,0,0,0-9.3,2.014,2.276,2.276,0,0,1-1.924.007,26.5,26.5,0,0,0-10.52-2.081,46.728,46.728,0,0,0-13.973,2.075c-1.578.471-2.222.218-2.973-1.216V34.743a2.159,2.159,0,0,1,2.39-1.457c.736.051,1.479.01,2.219.01h1.23a1.438,1.438,0,0,0,.042-.192q0-1.831.006-3.662a1.976,1.976,0,0,1,2.012-2.222,29.969,29.969,0,0,1,8.883.431A19.975,19.975,0,0,1,49.489,32.9c.454.45.875.934,1.328,1.421.13-.138.234-.241.328-.352A19.17,19.17,0,0,1,61.57,27.853a30.028,30.028,0,0,1,9.635-.648,2.029,2.029,0,0,1,2.137,2.278c0,1.252,0,2.505,0,3.813,1.329,0,2.6-.007,3.871,0a1.878,1.878,0,0,1,2.013,2.006q0,17.84,0,35.68",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_121",
    "data-name": "Trazado 121",
    d: "M56.525,45.554a13.491,13.491,0,0,0-5.26-4.878,19.119,19.119,0,0,0-7.291-2.1c-1.317-.125-2.644-.141-4.009-.208V67.895c6.126-.07,11.856,1.057,16.745,5.24v-.551q0-13.179-.008-26.357a1.336,1.336,0,0,0-.177-.673",
    transform: "translate(-7.804 -7.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_122",
    "data-name": "Trazado 122",
    d: "M37.046,73.4a2.076,2.076,0,0,1-2.412-2.289c.041-8.1.02-16.2.02-24.307v-.653H32.636V77.568A48.815,48.815,0,0,1,50.9,76.251a15.9,15.9,0,0,0-5.864-2.419,25.076,25.076,0,0,0-7.993-.431",
    transform: "translate(-6.373 -9.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_123",
    "data-name": "Trazado 123",
    d: "M82.266,38.473a24.264,24.264,0,0,0-6.726.559,15.207,15.207,0,0,0-9.007,5.343,3.143,3.143,0,0,0-1.024,1.9q0,13.148,0,26.3c0,.154.022.307.04.539,4.865-4.16,10.6-5.269,16.713-5.218Z",
    transform: "translate(-12.792 -7.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_124",
    "data-name": "Trazado 124",
    d: "M87.185,46.861c0,7.933-.037,15.866.024,23.8.017,2.2-.849,2.915-3.009,2.721a22.507,22.507,0,0,0-11.162,1.672c-.739.322-1.436.74-2.153,1.114l.061.155a47.319,47.319,0,0,1,18.245,1.246v-31.4H87.185Z",
    transform: "translate(-13.842 -9.015)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLibro);
export default __webpack_public_path__ + "static/media/ico_libro.83bda4ac99fa31e432e5f62d251ae9cd.svg";
export { ForwardRef as ReactComponent };